var map = {
	"./cart.html": 2149,
	"./customer.html": 2150,
	"./gtmOrder.html": 2151,
	"./order.html": 2152,
	"./pageview.html": 2153,
	"./shopifyOrder.html": 2154,
	"./transactionCurrency.html": 2155,
	"./transactionCustomerID.html": 2156,
	"./transactionDiscount.html": 2157,
	"./transactionDiscountCode.html": 2158,
	"./transactionPaymentMethod.html": 2159,
	"./transactionProducts.html": 2160,
	"./transactionProductsBlock.html": 2161,
	"./transactionShipping.html": 2162
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2148;


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets ^\.\/.*\.html$
// module id = 2148
// module chunks = 0